import { lazyMountAndShowFullOptionsFromRoute } from "owa-options-view";
import { popoutProjectionMountedPromise } from "owa-popout-v2/lib/store/parentStore";

export interface OptionRouteParameters {
    optionKey?: string;
}

export default async function mailOptionsRouteHandler(parameters: OptionRouteParameters): Promise<void> {
    await popoutProjectionMountedPromise;
    await lazyMountAndShowFullOptionsFromRoute.importAndExecute(parameters.optionKey);
}
